import { Dispatcher } from 'flux';

class AssignmentDispatcher extends Dispatcher<{}> {
  constructor() {
    super();
    this.handleUpdateAssignmentForEditor = this.handleUpdateAssignmentForEditor.bind(
      this
    );
  }

  handleUpdateAssignmentForEditor(
    editor: string,
    assignments: AssignmentsByDate
  ) {
    this.dispatch({
      source: 'UPDATE_EDITOR_ASSIGNMENT',
      output: { editor, assignments },
    });
  }

  handleUpdateAssignmentForDates(assignments: {
    [editor: string]: AssignmentsByDate;
  }) {
    this.dispatch({
      source: 'UPDATE_ALL_ASSIGNMENTS',
      output: { assignments },
    });
  }
}

const instance = new AssignmentDispatcher();
export default instance;



// WEBPACK FOOTER //
// ./src/dispatchers/AssignmentDispatcher.ts